module.exports = __webpack_public_path__ + "img/4.98ee2aa3.png";